import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8l4 -4l4 4","key":"svg-0"}],["path",{"d":"M12 20v-16","key":"svg-1"}],["path",{"d":"M6 18c4 -1.333 6 -4.667 6 -10","key":"svg-2"}]]

const IconArrowMergeLeft = createReactComponent('outline', 'arrow-merge-left', 'ArrowMergeLeft', __iconNode);

export default IconArrowMergeLeft;